import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { useSelector } from 'react-redux';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import { Checkbox, Chip, FormControlLabel, Grid } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
    label: {
        margin: useTheme().spacing(1),
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
    margin: {
        margin: useTheme().spacing(1),
    },
    textField: {
        width: '25ch',
    },
    chip: {
        margin: useTheme().spacing(0.5),
    },
}));

const VehicleAutoComplete = ({ multiVehicles, setMultiVehicles, multiAssetIds, setMultiAssetIds, showAllVehiclesSelectOption = false }) => {
    const classes = useStyles();
    const assetNames = useSelector(assetNamesSelector);
    const assetOptions = assetNames ? Object.keys(assetNames) : [];

    const [vehicle, setVehicle] = useState("");
    const [assetId, setAssetId] = useState("");
    const [vehList, setvehList] = useState([]);
    const [allVehicles, setAllVehicles] = useState(false);

    useEffect(() => {
        setvehList(multiVehicles);
        setVehicle("");
    }, [multiVehicles])

    useEffect(() => {
        const allAssetIds = assetNames ? Object.keys(assetNames) : [];
        const allSelected = allAssetIds.length > 0 && multiAssetIds.length === allAssetIds.length;
        setAllVehicles(allSelected);
    }, [assetNames, multiAssetIds]);

    useEffect(() => {
        if (!showAllVehiclesSelectOption) {
            setAllVehicles(false);
        }
    }, [showAllVehiclesSelectOption]);

    useEffect(() => {
        if (!assetNames) {
            return;
        }
        const derivedVehicles = multiAssetIds.map(assetId => assetNames?.[assetId]?.regn || "");
        const needsSync = derivedVehicles.length !== multiVehicles.length
            || derivedVehicles.some((name, index) => name !== (multiVehicles[index] || ""));
        if (needsSync) {
            setMultiVehicles(derivedVehicles);
            setvehList(derivedVehicles);
        }
    }, [assetNames, multiAssetIds, multiVehicles, setMultiVehicles]);

    const onVehicleSelect = (e, newValue) => {
        setVehicle(newValue);
    }

    const onAssetIdChange = (e, newValue) => {
        setAssetId(newValue || "");
        if (!newValue) {
            return;
        }
        if (multiAssetIds.indexOf(newValue) === -1) {
            setMultiAssetIds([...multiAssetIds, newValue]);
            const regn = assetNames?.[newValue]?.regn || "";
            setMultiVehicles([...multiVehicles, regn]);
            setvehList([...multiVehicles, regn]);
        }
    }

    const alllVehiclesSelect = () => {
        if (!allVehicles) {
            let allVehiclenames = [];
            let allAssetIds = [];
            Object.keys(assetNames).forEach(assetId => {
                allVehiclenames.push(assetNames[assetId].regn);
                allAssetIds.push(assetId);
            })
            setMultiAssetIds(allAssetIds);
            setMultiVehicles(allVehiclenames);
        } else {
            setMultiAssetIds([]);
            setMultiVehicles([]);
        }
        setAllVehicles(!allVehicles);
    }

    const deselctAll = () => {
        setMultiAssetIds([]);
        setMultiVehicles([]);
        setAllVehicles(false);
    }

    const vehicleDeselect = (assetIdToRemove) => {
        const index = multiAssetIds.indexOf(assetIdToRemove);
        //console.log("MV delete", index);
        if (index !== -1) {
            let newv = [...multiVehicles];
            newv.splice(index, 1);
            let newa = [...multiAssetIds];
            newa.splice(index, 1);
            //console.log("newv", newv);
            setMultiVehicles(newv);
            setMultiAssetIds(newa);
            setvehList(newv);
        }
    }

    return (
        <Grid container item>
            <Grid item sm={12}>
                <FormControl className={classes.formControl}>
                    <Autocomplete
                        id="vehicle"
                        style={{ width: 200 }}
                        options={assetOptions}
                        getOptionLabel={(option) => option ? assetNames[option].regn : ""}
                        value={assetId}
                        onChange={onAssetIdChange}
                        inputValue={vehicle}
                        onInputChange={onVehicleSelect}
                        renderInput={(params) => <TextField variant="standard" {...params} label="Vehicle" />}
                    />
                </FormControl>
            </Grid>
            {
                showAllVehiclesSelectOption &&
                <Grid item sm={12}>
                    <FormControlLabel
                        control={<Checkbox checked={allVehicles} onChange={alllVehiclesSelect} name="All Vehicles" />}
                        label={<span style={{ color: 'DodgerBlue' }}>Select All Vehicles</span>}
                    />
                </Grid>
            }
            {
                showAllVehiclesSelectOption && allVehicles ?
                    <Chip
                        size="small"
                        label="All Vehicles Selected"
                        onDelete={deselctAll}
                        className={classes.chip}
                        key="all"
                        color="primary"
                        variant="outlined"
                    />
                    :
                    <Grid item sm={12}>
                        {multiAssetIds.map((assetId, index) => {
                            const label = assetNames?.[assetId]?.regn || multiVehicles[index] || assetId;
                            return (
                            <Chip
                                size="small"
                                label={label}
                                onDelete={() => vehicleDeselect(assetId)}
                                className={classes.chip}
                                key={`${assetId}-${index}`}
                                color="primary"
                                variant="outlined"
                            />
                            );
                        })}
                    </Grid>
            }

        </Grid>
    );
}

export default VehicleAutoComplete;
